import { ShareSettingsApi } from './apis/impls/share-api';
import { GetShareSettingsApi } from './apis/get-share-settings-api';
import { CreateShareCodeApi } from './apis/create-share-code-api';
import { GetCollaboratorsApi } from './apis/get-collaborators-api';
import { QueryGroupApi } from './apis/query-group-api';
import { QueryGroupMemberApi } from './apis/query-group-member-api';
import { QueryGroupMemberInFolderApi } from './apis/query-group-member-in-folder-api';
import { SwitchPublicShareApi } from './apis/switch-public-share-api';
import { UpdateCollaboratorApi } from './apis/update-collaborator-api';
import { ShareSpaceModelImpl } from './models/impls/share-space-model';
import { ShareSpaceModel } from './models/share-space-model';
import { GetCollaboratorsRepositoryImpl } from './repositories/impls/get-collaborators-repository';
import { QueryGroupMemberInFolderRepositoryImpl } from './repositories/impls/query-group-member-in-folder-repository';
import { QueryGroupRepositoryImpl } from './repositories/impls/query-group-repository';
import { ShareSettingsRepositoryImpl } from './repositories/impls/share-settings-repository';
import { UpdateCollaboratorsRepositoryImpl } from './repositories/impls/update-collaborators-repository';
import { CheckSpaceRoleService } from './services/check-space-role-service';
import { CollaboratorsService } from './services/collaborators-service';
import { GetCollaboratorsRepository } from './services/get-collaborators-repository';
import { CheckSpaceRoleServiceImpl } from './services/impls/check-space-role-service';
import { CollaboratorsServiceImpl } from './services/impls/collaborators-service';
import { ShareSettingsServiceImpl } from './services/impls/share-settings-service';
import { SpaceCollaboratorFactoryImpl } from './services/impls/space-collaborator';
import { QueryGroupMemberInFolderRepository } from './services/query-group-member-in-folder-repository';
import { QueryGroupRepository } from './services/query-group-repository';
import { ShareSettingsRepository } from './services/share-settings-repository';
import { ShareSettingsService } from './services/share-settings-service';
import { SpaceCollaboratorFactory } from './services/space-collaborator';
import { UpdateCollaboratorsRepository } from './services/update-collaborators-repository';
import { TransformCollaboratorImpl } from './utils/transform-collaborator';
import { TransformCollaborator } from './utils/transform-collaborator.interface';
export function shareSpace(bind) {
    bind(ShareSpaceModel).to(ShareSpaceModelImpl);
    bind(ShareSettingsService).to(ShareSettingsServiceImpl);
    bind(CollaboratorsService).to(CollaboratorsServiceImpl);
    bind(ShareSettingsRepository).to(ShareSettingsRepositoryImpl);
    bind(GetCollaboratorsRepository).to(GetCollaboratorsRepositoryImpl);
    bind(UpdateCollaboratorsRepository).to(UpdateCollaboratorsRepositoryImpl);
    bind(ShareSettingsApi).toSelf().inSingletonScope();
    bind(GetShareSettingsApi).toService(ShareSettingsApi);
    bind(CreateShareCodeApi).toService(ShareSettingsApi);
    bind(SwitchPublicShareApi).toService(ShareSettingsApi);
    bind(GetCollaboratorsApi).toService(ShareSettingsApi);
    bind(UpdateCollaboratorApi).toService(ShareSettingsApi);
    bind(QueryGroupApi).toService(ShareSettingsApi);
    bind(QueryGroupMemberApi).toService(ShareSettingsApi);
    bind(QueryGroupMemberInFolderApi).toService(ShareSettingsApi);
    bind(SpaceCollaboratorFactory).to(SpaceCollaboratorFactoryImpl);
    bind(CheckSpaceRoleService).to(CheckSpaceRoleServiceImpl);
    bind(TransformCollaborator).to(TransformCollaboratorImpl);
    bind(QueryGroupMemberInFolderRepository).to(QueryGroupMemberInFolderRepositoryImpl);
    bind(QueryGroupRepository).to(QueryGroupRepositoryImpl);
}
